// extracted by mini-css-extract-plugin
export var borderRadius = "_5l-4";
export var large = "_5l-3";
export var logoContainer = "_5l-0";
export var nameLogo = "_5l-2";
export var small = "_5l-1";